export const countries = [
  { name: "中國香港", code: "HK" },
  { name: "中國台灣", code: "TW" },
  { name: "中國澳門", code: "MO" },
  { name: "中國", code: "CN" },
  { name: "阿富汗", code: "AF" },
  { name: "阿爾巴尼亞", code: "AL" },
  { name: "阿爾及利亞", code: "DZ" },
  { name: "安道爾", code: "AD" },
  { name: "安哥拉", code: "AO" },
  { name: "安提瓜和巴布達", code: "AG" },
  { name: "阿根廷", code: "AR" },
  { name: "亞美尼亞", code: "AM" },
  { name: "澳大利亞", code: "AU" },
  { name: "奧地利", code: "AT" },
  { name: "阿塞拜疆", code: "AZ" },
  { name: "巴哈馬", code: "BS" },
  { name: "巴林", code: "BH" },
  { name: "孟加拉國", code: "BD" },
  { name: "巴貝多", code: "BB" },
  { name: "白俄羅斯", code: "BY" },
  { name: "比利時", code: "BE" },
  { name: "伯利茲", code: "BZ" },
  { name: "貝寧", code: "BJ" },
  { name: "不丹", code: "BT" },
  { name: "玻利維亞", code: "BO" },
  { name: "波斯尼亞和黑塞哥維那", code: "BA" },
  { name: "博茨瓦納", code: "BW" },
  { name: "巴西", code: "BR" },
  { name: "保加利亞", code: "BG" },
  { name: "布基納法索", code: "BF" },
  { name: "布隆迪", code: "BI" },
  { name: "喀麥隆", code: "CM" },
  { name: "加拿大", code: "CA" },
  { name: "中非共和國", code: "CF" },
  { name: "乍得", code: "TD" },
  { name: "智利", code: "CL" },
  { name: "哥倫比亞", code: "CO" },
  { name: "科摩羅", code: "KM" },
  { name: "剛果（布）", code: "CG" },
  { name: "剛果（金）", code: "CD" },
  { name: "哥斯達黎加", code: "CR" },
  { name: "克羅地亞", code: "HR" },
  { name: "古巴", code: "CU" },
  { name: "塞浦路斯", code: "CY" },
  { name: "捷克共和國", code: "CZ" },
  { name: "丹麥", code: "DK" },
  { name: "吉布提", code: "DJ" },
  { name: "多米尼克", code: "DM" },
  { name: "多米尼加共和國", code: "DO" },
  { name: "厄瓜多爾", code: "EC" },
  { name: "埃及", code: "EG" },
  { name: "薩爾瓦多", code: "SV" },
  { name: "赤道幾內亞", code: "GQ" },
  { name: "厄利垂亞", code: "ER" },
  { name: "愛沙尼亞", code: "EE" },
  { name: "埃塞俄比亞", code: "ET" },
  { name: "斐濟", code: "FJ" },
  { name: "芬蘭", code: "FI" },
  { name: "法國", code: "FR" },
  { name: "加蓬", code: "GA" },
  { name: "岡比亞", code: "GM" },
  { name: "格魯吉亞", code: "GE" },
  { name: "德國", code: "DE" },
  { name: "加納", code: "GH" },
  { name: "希臘", code: "GR" },
  { name: "格林納達", code: "GD" },
  { name: "危地馬拉", code: "GT" },
  { name: "幾內亞", code: "GN" },
  { name: "幾內亞比紹", code: "GW" },
  { name: "圭亞那", code: "GY" },
  { name: "海地", code: "HT" },
  { name: "洪都拉斯", code: "HN" },
  { name: "匈牙利", code: "HU" },
  { name: "冰島", code: "IS" },
  { name: "印度", code: "IN" },
  { name: "印度尼西亞", code: "ID" },
  { name: "伊朗", code: "IR" },
  { name: "伊拉克", code: "IQ" },
  { name: "愛爾蘭", code: "IE" },
  { name: "以色列", code: "IL" },
  { name: "意大利", code: "IT" },
  { name: "牙買加", code: "JM" },
  { name: "日本", code: "JP" },
  { name: "約旦", code: "JO" },
  { name: "卡塔爾", code: "QA" },
  { name: "肯尼亞", code: "KE" },
  { name: "基里巴斯", code: "KI" },
  { name: "韓國", code: "KR" },
  { name: "科威特", code: "KW" },
  { name: "吉爾吉斯斯坦", code: "KG" },
  { name: "老挝", code: "LA" },
  { name: "拉脫維亞", code: "LV" },
  { name: "黎巴嫩", code: "LB" },
  { name: "賴索托", code: "LS" },
  { name: "利比里亞", code: "LR" },
  { name: "利比亞", code: "LY" },
  { name: "列支敦士登", code: "LI" },
  { name: "立陶宛", code: "LT" },
  { name: "盧森堡", code: "LU" },
  { name: "馬其頓", code: "MK" },
  { name: "馬達加斯加", code: "MG" },
  { name: "馬拉維", code: "MW" },
  { name: "馬來西亞", code: "MY" },
  { name: "馬爾地夫", code: "MV" },
  { name: "馬里", code: "ML" },
  { name: "馬爾他", code: "MT" },
  { name: "馬紹爾群島", code: "MH" },
  { name: "毛里塔尼亞", code: "MR" },
  { name: "毛里裘斯", code: "MU" },
  { name: "墨西哥", code: "MX" },
  { name: "密克羅尼西亞聯邦", code: "FM" },
  { name: "摩爾多瓦", code: "MD" },
  { name: "摩納哥", code: "MC" },
  { name: "蒙古", code: "MN" },
  { name: "蒙特內哥羅", code: "ME" },
  { name: "摩洛哥", code: "MA" },
  { name: "莫桑比克", code: "MZ" },
  { name: "緬甸", code: "MM" },
  { name: "納米比亞", code: "NA" },
  { name: "瑙魯", code: "NR" },
  { name: "尼泊爾", code: "NP" },
  { name: "荷蘭", code: "NL" },
  { name: "紐西蘭", code: "NZ" },
  { name: "尼加拉瓜", code: "NI" },
  { name: "尼日利亞", code: "NG" },
  { name: "北韓", code: "KP" },
  { name: "挪威", code: "NO" },
  { name: "阿曼", code: "OM" },
  { name: "巴基斯坦", code: "PK" },
  { name: "帛琉", code: "PW" },
  { name: "巴拿馬", code: "PA" },
  { name: "巴布亞新幾內亞", code: "PG" },
  { name: "巴拉圭", code: "PY" },
  { name: "祕魯", code: "PE" },
  { name: "菲律賓", code: "PH" },
  { name: "波蘭", code: "PL" },
  { name: "葡萄牙", code: "PT" },
  { name: "卡塔爾", code: "QA" },
  { name: "羅馬尼亞", code: "RO" },
  { name: "俄羅斯聯邦", code: "RU" },
  { name: "盧旺達", code: "RW" },
  { name: "聖基茨和尼維斯", code: "KN" },
  { name: "聖盧西亞", code: "LC" },
  { name: "聖文森特和格林納丁斯", code: "VC" },
  { name: "薩摩亞", code: "WS" },
  { name: "聖馬力諾", code: "SM" },
  { name: "聖多美和普林西比", code: "ST" },
  { name: "沙烏地阿拉伯", code: "SA" },
  { name: "塞內加爾", code: "SN" },
  { name: "塞爾維亞", code: "RS" },
  { name: "塞舌爾", code: "SC" },
  { name: "獅子山", code: "SL" },
  { name: "新加坡", code: "SG" },
  { name: "斯洛伐克", code: "SK" },
  { name: "斯洛文尼亞", code: "SI" },
  { name: "所羅門群島", code: "SB" },
  { name: "索馬里", code: "SO" },
  { name: "南非", code: "ZA" },
  { name: "南蘇丹", code: "SS" },
  { name: "西班牙", code: "ES" },
  { name: "斯里蘭卡", code: "LK" },
  { name: "蘇丹", code: "SD" },
  { name: "蘇里南", code: "SR" },
  { name: "斯威士蘭", code: "SZ" },
  { name: "瑞典", code: "SE" },
  { name: "瑞士", code: "CH" },
  { name: "敘利亞", code: "SY" },
  { name: "塔吉克斯坦", code: "TJ" },
  { name: "坦尚尼亞", code: "TZ" },
  { name: "泰國", code: "TH" },
  { name: "多哥", code: "TG" },
  { name: "東帝汶", code: "TL" },
  { name: "湯加", code: "TO" },
  { name: "特立尼達和多巴哥", code: "TT" },
  { name: "突尼斯", code: "TN" },
  { name: "土耳其", code: "TR" },
  { name: "土庫曼斯坦", code: "TM" },
  { name: "烏干達", code: "UG" },
  { name: "烏克蘭", code: "UA" },
  { name: "阿拉伯聯合酋長國", code: "AE" },
  { name: "英國", code: "GB" },
  { name: "美國", code: "US" },
  { name: "烏拉圭", code: "UY" },
  { name: "烏茲別克斯坦", code: "UZ" },
  { name: "瓦努阿圖", code: "VU" },
  { name: "梵蒂岡", code: "VA" },
  { name: "委內瑞拉", code: "VE" },
  { name: "越南", code: "VN" },
  { name: "也門", code: "YE" },
  { name: "尚比亞", code: "ZM" },
  { name: "津巴布韋", code: "ZW" },
];
